import React, { Suspense } from 'react';
import { Homepage, ROUTES, CareerPage, ContactPage, BrandPage, BlogPage, ProfilePage, BlogDetailPage } from "./Routes";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { basename } from '~/utils/useBaseName';
import ScrollToTop from '~/utils/useScrollTop';
import { LoadingProvider } from '../providers/LoadingProviders';
import LoadingPage from '~/components/Loading';
import { PageCacheProvider } from '../providers/PageCacheContext';

function AppRoutes() {
    return (
        <BrowserRouter basename={basename}>
            <PageCacheProvider>
                <LoadingProvider>
                    <Suspense>
                        <ScrollToTop />
                        <LoadingPage />
                        <Routes>
                            <Route exact path={ROUTES.Homepage} index element={<Homepage />} />
                            <Route path={ROUTES.Profile} element={<ProfilePage />} />
                            <Route path={ROUTES.Career} element={<CareerPage />} />
                            <Route path={ROUTES.Contact} element={<ContactPage />} />
                            <Route path={ROUTES.Brand} element={<BrandPage />} />
                            <Route path={ROUTES.Blog} element={<BlogPage />} />
                            <Route path={ROUTES.BlogDetail} element={<BlogDetailPage />} />
                        </Routes>
                    </Suspense>
                </LoadingProvider>
            </PageCacheProvider>
        </BrowserRouter>
    );
}

export default AppRoutes;